<div class="p-2">
  <div *ngIf="messages.length > 0;else no_messages" class="messages-container overflow-y-scroll" >
    <div *ngFor="let message of messages">
      <div class="message-box pb-4 mb-4"
        [ngStyle]="{'background-color': message.messageType === 1 ? '#F2F8FF' : '#FFEFDE'}">
        <div class="flex justify-content-between pr-4">
          <h3>{{message.title}}</h3>
          <span *ngIf="selectedViewType === ViewType.DOR_VIEW && (message.canEdit || message.canDelete)" [matMenuTriggerFor]="menu" class="ellipsis-icon cursor-pointer">&#8942;</span>
          <mat-menu #menu="matMenu" xPosition="before">
            <button *ngIf="message.canEdit" (click)="editMessage(message)" mat-menu-item>Edit</button>
            <button *ngIf="message.canDelete" (click)="openDeleteConfirmation(message)" mat-menu-item>Delete</button>
          </mat-menu>
        </div>
        <h5>Message:</h5>
        <p class="pb-4">{{message.message}}</p>
        <div class="owner">
          {{message.author}} | {{message.date | date : "MM/dd/yyyy h:mm a" }}
        </div>
      </div>
    </div>
  </div>
  <ng-template #no_messages>
    <div class="messages-container centered-text">
      No Messages
    </div>
  </ng-template>
  <div class="add-button-container text-right">
    <thera-button *ngIf="selectedViewType === ViewType.DOR_VIEW" class="rounded-md mr-3" (clicked)="addMessage()" [config]="{
      variant: buttonVariant.PRIMARY,
      text: 'Add'
    }" />
  </div>  
</div>